import React from "react";
import PropTypes from "prop-types";

import form, { props } from "../HOC";
import {noop} from "lodash-es";
import uniqueId from "lodash-es/uniqueId";

class Form extends React.Component {
    render() {
        return this.props.children(this.props);
    }
}

Form.defaultProps = {
    id: uniqueId(`form`),
    onSuccess: noop,
    onError: noop,
    submit: noop,
};

Form.propTypes = {
    ...props,
    children: PropTypes.func.isRequired,
    message: PropTypes.object,
    saving: PropTypes.bool,
    dismissMessage: PropTypes.func,
    isDirty: PropTypes.func,
    invalidFields: PropTypes.instanceOf(Set),
};

export default form(Form);
